module.exports = __webpack_public_path__ + "img/Unidad9-5.e1a1986e.png";